var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visibleSnackbar)?_c('div',{staticClass:"snackbar"},[_c('span',[_vm._v("Você alterou a visualização para outro contrato.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }